import { SELECT_PRODUCER_YEAR, CLEAR_PRODUCER_YEAR } from './actions';

export const selectProducerYearAction = (yearData: any) => {
	return { type: SELECT_PRODUCER_YEAR, payload: yearData };
};

export const clearProducerYearAction = () => {
	return { type: CLEAR_PRODUCER_YEAR };
};
